module.exports = __webpack_public_path__ + "static/media/img_logo1024@2x.cbeaa341.png";